import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

export const login = async (data) => {
  const response = await apiClient.request('POST', '/admin/auth/login', data);
  if (!isApiResponseError(response)) {
    apiClient.setAuthToken(response.data?.data?.access_token);
    return {
      ...response.data,
      ...validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const register = async (data) => {
  const response = await apiClient.request('POST', '/admin/auth/register', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const resetPassword = async (data) => {
  const response = await apiClient.request('POST', '/admin/auth/reset-password', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const confirmResetPassword = async (data) => {
  const response = await apiClient.request('POST', '/admin/auth/confirm-reset-password', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
